import React from 'react';
import { connect } from 'react-redux';
import { fromJS } from 'immutable';

import AvatarProfile from '../../components/avatar';
import {
  showRemoveModal,
  hideRemoveModal,
} from '../../containers/campaign-members-manage/actions';
import {
  INFLUENCER,
  TALENT_AGENT,
  PRODUCTION_COMPANY,
} from '../../utils/static-configuration';

class Member extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      open: false,
    };
  }

  toggleMeta = () => {
    if (this.state.open) {
      this.setState({ open: false });
    } else {
      this.setState({ open: true });
    }
  };

  render() {
    const {
      member,
      deleteMember,
      deletable,
      removeMemberLoading,
      removeMemberId,
      onShowRemoveModal,
      onHideRemoveModal,
    } = this.props;

    const id = member.get('id');
    const name = member.get('name');
    const email = member.get('email');
    const role = member.get('role');
    const link = member.get('link');

    // Member role specific information
    const influencersManaging =
      member.getIn(['metadata', 'influencersManaging']) || fromJS({});
    const platforms = member.getIn(['metadata', 'platforms']) || fromJS([]);
    const socialHandle = member.getIn(['metadata', 'socialHandle']) || '';
    const company = member.getIn(['metadata', 'company']) || '';

    return (
      <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-2-6 grid-xl-2-6">
        <div className="member">
          <div className="member-data">
            <div className="left">
              <AvatarProfile name={name} role={role} email={email} size={44} />
            </div>
            <div className="center">
              <h2>{name && name.length > 0 ? name : email}</h2>
            </div>
            {deletable &&
              <div className="right">
                <img
                  src="/icons/close.svg"
                  alt="close"
                  onClick={() => onShowRemoveModal(id)}
                />
              </div>}
          </div>
          <div className="member-meta">
            <div className={this.state.open ? 'meta-toggle open' : 'meta-toggle'} onClick={this.toggleMeta} >
              <p className="small light">Show details</p>
              <div className="container">
                <img src="/icons/chevron-down.svg" alt="show details arrow" />
              </div>
            </div>
            {this.state.open &&
              <div className="meta-details">
                <p className="small">
                  <span className="light">Email:&nbsp;&nbsp;</span>{email}
                </p>
                { link &&
                  <p className="small">
                    <span className="light">Invite:&nbsp;&nbsp;</span>{link}
                  </p>}
                { role === INFLUENCER &&
                  <div>
                    <p className="small">
                      <span className="light">Social Handle:&nbsp;&nbsp;</span>
                      {socialHandle}
                    </p>
                    <p className="small">
                      <span className="light">Platforms:&nbsp;&nbsp;</span>
                      {platforms.map((socialAccount, index) => (
                        <span key={socialAccount}>
                          {socialAccount}
                          {index + 1 < platforms.size ? ', ' : ''}
                        </span>
                      ))}
                    </p>
                  </div>}
                { role === TALENT_AGENT &&
                  <p className="small">
                    <span className="light">Influencers:&nbsp;&nbsp;</span>
                    {influencersManaging.map(influencer => (
                      <span key={influencer}>{influencer}</span>
                    ))}
                    {' '}
                  </p>}
                { role === PRODUCTION_COMPANY &&
                  <p className="small">
                    <span className="light">Company:&nbsp;&nbsp;</span>{company}
                  </p>}
              </div>}
          </div>
        </div>
        <div className={removeMemberId === id ? 'custom-modal visible' : 'custom-modal'} >
          <div className="modal-content">
            <div className="top">
              <h3>Are you sure?</h3>
            </div>
            <div className="modal-close">
              <img src="/icons/close.svg" alt="close" onClick={() => onHideRemoveModal()} />
            </div>
            <div className="center">
              <p>
                Before you continue, be aware that removing a campaign member cannot be undone.
              </p>
              <div className="spacer" />
              <div className="spacer" />
              { removeMemberLoading
                ? <button className="large rose stretch">
                    <ul className="dots">
                      <li id="dot1" />
                      <li />
                      <li id="dot2" />
                      <li />
                      <li id="dot3" />
                    </ul>
                  </button>
                : <button className="large rose stretch" onClick={() => deleteMember()} >
                    <p>Remove member</p>
                  </button>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Member.propTypes = {
  member: React.PropTypes.object,
};

const mapStateToProps = state => {
  return {
    removeMemberLoading: state.members.get('removeMemberLoading'),
    removeMemberError: state.members.get('removeMemberError'),
    removeMemberId: state.members.get('removeMemberId'),
  };
};

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    onShowRemoveModal: id => dispatch(showRemoveModal(id)),
    onHideRemoveModal: () => dispatch(hideRemoveModal()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Member);



/** WEBPACK FOOTER **
 ** ./src/components/member/index.js
 **/